import React from "react";
import Typography from "@material-ui/core/Typography";
import { Table } from "react-bootstrap";
const SupportedPlatforms = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Supported Platforms
      </Typography>
      <Typography paragraph variant="h5">
        Learn about the platforms, from modern to old, that are supported by
        Invifo platform.
      </Typography>
      <Typography paragraph variant="body1">
        Invifo platform is designed to be UI responsive, where the user can
        access the platform using the browser via PC or smartphone. The platform
        also can be accessed using mobile apps but with limited features for
        now.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Supported Browser.
      </Typography>
      <Typography paragraph variant="body1">
        The Invifo platform supports the latest, stable releases of all major
        browsers and platforms. But our recommendation is to use Google Chrome
        as it is a more stable browser. If you are facing some issues when
        accessing the platform using a browser like Safari, please try our
        browser recommendation.
      </Typography>
      <Table bordered striped size="sm" responsive="xl">
        <thead>
          <tr>
            <th>
              <Typography className="mx-1 kt-font-bolder">Chrome</Typography>
            </th>
            <th>
              <Typography className="mx-1 kt-font-bolder">Edge</Typography>
            </th>
            <th>
              <Typography className="mx-1 kt-font-bolder">Firefox</Typography>
            </th>
            <th>
              <Typography className="mx-1 kt-font-bolder">
                Safari (macOS)
              </Typography>
            </th>
            <th>
              <Typography className="mx-1 kt-font-bolder">
                Safari (iOS)
              </Typography>
            </th>
            <th>
              <Typography className="mx-1 kt-font-bolder">IE</Typography>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Typography className="mx-1 my-1">{`>= 90`}</Typography>
            </td>
            <td>
              <Typography className="mx-1 my-1">{`>= 91`}</Typography>
            </td>
            <td>
              <Typography className="mx-1 my-1">{`>= 78`}</Typography>
            </td>
            <td>
              <Typography className="mx-1 my-1">{`>= 14`}</Typography>
            </td>
            <td>
              <Typography className="mx-1 my-1">{`>= 12.5`}</Typography>
            </td>
            <td>
              <Typography className="mx-1 my-1">{`11`}</Typography>
            </td>
          </tr>
        </tbody>
      </Table>
    </React.Fragment>
  );
};

export default SupportedPlatforms;
